/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssessmentType,
  BadRequestResponse,
  ClassRecord,
  ConflictResponse,
  CreateAssessmentTypeRequest,
  CreateGradeRequest,
  CreateGradeScaleRequest,
  CreateMaterialRequest,
  ForbiddenResponse,
  GetStudentPerformanceParams,
  Grade,
  GradeScale,
  ListMaterialsParams,
  ListMyPerformanceParams,
  MaterialPage,
  MaterialUpload,
  NotFoundResponse,
  OccurrenceRecord,
  PutParticipantRecordRequest,
  ServiceUnavailableResponse,
  SignedURL,
  StudentPerformance,
  UnauthorizedResponse,
  UnprocessableEntityResponse,
  UpdateAssessmentTypeRequest
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetOccurrenceRecordUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/record`
}

/**
 * Professor da ocorrencia e Super Admin. `internalComment` e omitido para
 * quem nao e o autor nem Super Admin, e a autoria de registro lancado por
 * outro professor vem com `personId` e `displayName` nulos — o professor
 * atual ve o historico pedagogico, nunca quem o lancou.
 * @summary Le o registro pedagogico de uma aula
 */
export const getOccurrenceRecord = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<OccurrenceRecord> => {

  return apiFetch<OccurrenceRecord>(getGetOccurrenceRecordUrl(occurrenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOccurrenceRecordQueryKey = (occurrenceId: string,) => {
    return [
    `/v1/occurrences/${occurrenceId}/record`
    ] as const;
    }


export const getGetOccurrenceRecordQueryOptions = <TData = Awaited<ReturnType<typeof getOccurrenceRecord>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrenceRecord>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOccurrenceRecordQueryKey(occurrenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOccurrenceRecord>>> = ({ signal }) => getOccurrenceRecord(occurrenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: occurrenceId !== null && occurrenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOccurrenceRecord>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOccurrenceRecordQueryResult = NonNullable<Awaited<ReturnType<typeof getOccurrenceRecord>>>
export type GetOccurrenceRecordQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetOccurrenceRecord<TData = Awaited<ReturnType<typeof getOccurrenceRecord>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrenceRecord>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOccurrenceRecord>>,
          TError,
          Awaited<ReturnType<typeof getOccurrenceRecord>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOccurrenceRecord<TData = Awaited<ReturnType<typeof getOccurrenceRecord>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrenceRecord>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOccurrenceRecord>>,
          TError,
          Awaited<ReturnType<typeof getOccurrenceRecord>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOccurrenceRecord<TData = Awaited<ReturnType<typeof getOccurrenceRecord>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrenceRecord>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Le o registro pedagogico de uma aula
 */

export function useGetOccurrenceRecord<TData = Awaited<ReturnType<typeof getOccurrenceRecord>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrenceRecord>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOccurrenceRecordQueryOptions(occurrenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPutParticipantRecordUrl = (occurrenceId: string,
    participantId: string,) => {




  return `/v1/occurrences/${occurrenceId}/participants/${participantId}/record`
}

/**
 * O prazo de lancamento e a janela de edicao continuam abertos na §15.2 e
 * nascem como conteudo provisorio configuravel, nao como formato.
 *
 * A rota e enderecada por `occurrenceId` + `participantId` e **nao aceita
 * `studentId`** em nenhuma hipotese. Dois alunos podem aparecer como
 * `Joao S.` na mesma lista; a defesa nao e um rotulo melhor, e o professor
 * nunca escolher aluno numa lista. Isso precisa estar no formato da rota,
 * porque recomendacao de tela a proxima tela desfaz.
 * @summary Lanca ou substitui o registro pedagogico de um participante
 */
export const putParticipantRecord = async (occurrenceId: string,
    participantId: string,
    putParticipantRecordRequest: PutParticipantRecordRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ClassRecord> => {

  return apiFetch<ClassRecord>(getPutParticipantRecordUrl(occurrenceId,participantId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putParticipantRecordRequest)
  }
);}





export const getPutParticipantRecordMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putParticipantRecord>>, TError,{occurrenceId: string;participantId: string;data: PutParticipantRecordRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putParticipantRecord>>, TError,{occurrenceId: string;participantId: string;data: PutParticipantRecordRequest}, TContext> => {

const mutationKey = ['putParticipantRecord'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putParticipantRecord>>, {occurrenceId: string;participantId: string;data: PutParticipantRecordRequest}> = (props) => {
          const {occurrenceId,participantId,data} = props ?? {};

          return  putParticipantRecord(occurrenceId,participantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutParticipantRecordMutationResult = NonNullable<Awaited<ReturnType<typeof putParticipantRecord>>>
    export type PutParticipantRecordMutationBody = PutParticipantRecordRequest
    export type PutParticipantRecordMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse

    /**
 * @summary Lanca ou substitui o registro pedagogico de um participante
 */
export const usePutParticipantRecord = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putParticipantRecord>>, TError,{occurrenceId: string;participantId: string;data: PutParticipantRecordRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putParticipantRecord>>,
        TError,
        {occurrenceId: string;participantId: string;data: PutParticipantRecordRequest},
        TContext
      > => {
      return useMutation(getPutParticipantRecordMutationOptions(options), queryClient);
    }
    export const getCreateParticipantGradeUrl = (occurrenceId: string,
    participantId: string,) => {




  return `/v1/occurrences/${occurrenceId}/participants/${participantId}/grades`
}

/**
 * As escalas de nota e os tipos de avaliacao continuam abertos na §15.2 e
 * nascem como conteudo provisorio; o formato da operacao nao depende deles.
 *
 * Enderecada por `occurrenceId` + `participantId`, nunca por `studentId`,
 * pela mesma razao de `putParticipantRecord`.
 *
 * Exatamente um entre `numericValue`, `conceptValue` e `rubricValue` e
 * preenchido, conforme o `kind` da escala. A exclusividade e documentada
 * aqui e validada pelo backend com 422; nao e expressa por `oneOf` porque
 * `oneOf` em corpo de requisicao gera cliente ruim em TypeScript.
 * @summary Lanca uma nota para um participante da aula
 */
export const createParticipantGrade = async (occurrenceId: string,
    participantId: string,
    createGradeRequest: CreateGradeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Grade> => {

  return apiFetch<Grade>(getCreateParticipantGradeUrl(occurrenceId,participantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createGradeRequest)
  }
);}





export const getCreateParticipantGradeMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createParticipantGrade>>, TError,{occurrenceId: string;participantId: string;data: CreateGradeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createParticipantGrade>>, TError,{occurrenceId: string;participantId: string;data: CreateGradeRequest}, TContext> => {

const mutationKey = ['createParticipantGrade'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createParticipantGrade>>, {occurrenceId: string;participantId: string;data: CreateGradeRequest}> = (props) => {
          const {occurrenceId,participantId,data} = props ?? {};

          return  createParticipantGrade(occurrenceId,participantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateParticipantGradeMutationResult = NonNullable<Awaited<ReturnType<typeof createParticipantGrade>>>
    export type CreateParticipantGradeMutationBody = CreateGradeRequest
    export type CreateParticipantGradeMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse

    /**
 * @summary Lanca uma nota para um participante da aula
 */
export const useCreateParticipantGrade = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createParticipantGrade>>, TError,{occurrenceId: string;participantId: string;data: CreateGradeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createParticipantGrade>>,
        TError,
        {occurrenceId: string;participantId: string;data: CreateGradeRequest},
        TContext
      > => {
      return useMutation(getCreateParticipantGradeMutationOptions(options), queryClient);
    }
    export const getListMyPerformanceUrl = (params?: ListMyPerformanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/me/performance?${stringifiedParams}` : `/v1/me/performance`
}

/**
 * Do aluno. Nao inclui comentario interno.
 *
 * Carrega a frequencia apurada em `attendance` e `frequency`. Sem
 * percentual: a razao de frequencia depende de um divisor que a §15.2
 * ainda nao fixa, e esta registrado no README como pendencia.
 *
 * **Paginado por aula.** `limit` conta aulas, nao linhas: a pagina traz as
 * `limit` aulas mais recentes do aluno, e `grades`, `records` e
 * `attendance` carregam as linhas dessas aulas e de mais nenhuma. Sem esse
 * recorte comum, um cursor sobre tres listas de tamanhos diferentes nao
 * teria significado unico.
 * @summary Desempenho academico do proprio aluno
 */
export const listMyPerformance = async (params?: ListMyPerformanceParams, options?: Parameters<typeof apiFetch>[1]): Promise<StudentPerformance> => {

  return apiFetch<StudentPerformance>(getListMyPerformanceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyPerformanceQueryKey = (params?: ListMyPerformanceParams,) => {
    return [
    `/v1/me/performance`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMyPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof listMyPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListMyPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyPerformanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyPerformance>>> = ({ signal }) => listMyPerformance(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyPerformance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof listMyPerformance>>>
export type ListMyPerformanceQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListMyPerformance<TData = Awaited<ReturnType<typeof listMyPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListMyPerformanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPerformance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyPerformance>>,
          TError,
          Awaited<ReturnType<typeof listMyPerformance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyPerformance<TData = Awaited<ReturnType<typeof listMyPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMyPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPerformance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyPerformance>>,
          TError,
          Awaited<ReturnType<typeof listMyPerformance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyPerformance<TData = Awaited<ReturnType<typeof listMyPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMyPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Desempenho academico do proprio aluno
 */

export function useListMyPerformance<TData = Awaited<ReturnType<typeof listMyPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMyPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyPerformanceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetStudentPerformanceUrl = (studentId: string,
    params?: GetStudentPerformanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/students/${studentId}/performance?${stringifiedParams}` : `/v1/students/${studentId}/performance`
}

/**
 * Professor com vinculo ativo e Super Admin. Esta operacao aceita
 * `studentId` porque e **leitura**, e a leitura chega por um caminho que o
 * professor ja tem — o contexto de uma aula dele com aquele aluno. O que a
 * §9.2 proibe e escrita enderecada por aluno escolhido numa lista.
 *
 * Devolve `StudentSummary`, que nao carrega dado pessoal, e nunca
 * `StudentAdminDetail`.
 *
 * Carrega a mesma frequencia que o aluno le de si (`attendance` e
 * `frequency`), e nada alem dela: o autor e a justificativa do ajuste de
 * presenca ficam fora do corpo para os dois leitores, e continuam
 * alcancaveis so por `listOccurrenceAttendance`, que e de Super Admin.
 *
 * **Paginado por aula**, com a mesma unidade de `listMyPerformance`:
 * `limit` conta aulas, e as tres listas trazem as linhas das aulas da
 * pagina.
 * @summary Desempenho academico de um aluno
 */
export const getStudentPerformance = async (studentId: string,
    params?: GetStudentPerformanceParams, options?: Parameters<typeof apiFetch>[1]): Promise<StudentPerformance> => {

  return apiFetch<StudentPerformance>(getGetStudentPerformanceUrl(studentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStudentPerformanceQueryKey = (studentId: string,
    params?: GetStudentPerformanceParams,) => {
    return [
    `/v1/students/${studentId}/performance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStudentPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof getStudentPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(studentId: string,
    params?: GetStudentPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentPerformanceQueryKey(studentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentPerformance>>> = ({ signal }) => getStudentPerformance(studentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: studentId !== null && studentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentPerformance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStudentPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentPerformance>>>
export type GetStudentPerformanceQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetStudentPerformance<TData = Awaited<ReturnType<typeof getStudentPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 studentId: string,
    params: undefined |  GetStudentPerformanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentPerformance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentPerformance>>,
          TError,
          Awaited<ReturnType<typeof getStudentPerformance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStudentPerformance<TData = Awaited<ReturnType<typeof getStudentPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 studentId: string,
    params?: GetStudentPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentPerformance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentPerformance>>,
          TError,
          Awaited<ReturnType<typeof getStudentPerformance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStudentPerformance<TData = Awaited<ReturnType<typeof getStudentPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 studentId: string,
    params?: GetStudentPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Desempenho academico de um aluno
 */

export function useGetStudentPerformance<TData = Awaited<ReturnType<typeof getStudentPerformance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 studentId: string,
    params?: GetStudentPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStudentPerformanceQueryOptions(studentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAssessmentTypesUrl = () => {




  return `/v1/assessment-types`
}

/**
 * Os tipos em si continuam abertos na §15.2 e nascem como conteudo provisorio
 * que impede o boot em producao enquanto nao for ratificado.
 * @summary Lista tipos de avaliacao configurados
 */
export const listAssessmentTypes = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AssessmentType[]> => {

  return apiFetch<AssessmentType[]>(getListAssessmentTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssessmentTypesQueryKey = () => {
    return [
    `/v1/assessment-types`
    ] as const;
    }


export const getListAssessmentTypesQueryOptions = <TData = Awaited<ReturnType<typeof listAssessmentTypes>>, TError = UnauthorizedResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTypes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssessmentTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssessmentTypes>>> = ({ signal }) => listAssessmentTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssessmentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listAssessmentTypes>>>
export type ListAssessmentTypesQueryError = UnauthorizedResponse


export function useListAssessmentTypes<TData = Awaited<ReturnType<typeof listAssessmentTypes>>, TError = UnauthorizedResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentTypes>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentTypes<TData = Awaited<ReturnType<typeof listAssessmentTypes>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentTypes>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentTypes<TData = Awaited<ReturnType<typeof listAssessmentTypes>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTypes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista tipos de avaliacao configurados
 */

export function useListAssessmentTypes<TData = Awaited<ReturnType<typeof listAssessmentTypes>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTypes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssessmentTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateAssessmentTypeUrl = () => {




  return `/v1/assessment-types`
}

/**
 * Exclusiva de Super Admin.
 * @summary Cria um tipo de avaliacao
 */
export const createAssessmentType = async (createAssessmentTypeRequest: CreateAssessmentTypeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<AssessmentType> => {

  return apiFetch<AssessmentType>(getCreateAssessmentTypeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAssessmentTypeRequest)
  }
);}





export const getCreateAssessmentTypeMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssessmentType>>, TError,{data: CreateAssessmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAssessmentType>>, TError,{data: CreateAssessmentTypeRequest}, TContext> => {

const mutationKey = ['createAssessmentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssessmentType>>, {data: CreateAssessmentTypeRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAssessmentType(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssessmentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createAssessmentType>>>
    export type CreateAssessmentTypeMutationBody = CreateAssessmentTypeRequest
    export type CreateAssessmentTypeMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse

    /**
 * @summary Cria um tipo de avaliacao
 */
export const useCreateAssessmentType = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssessmentType>>, TError,{data: CreateAssessmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAssessmentType>>,
        TError,
        {data: CreateAssessmentTypeRequest},
        TContext
      > => {
      return useMutation(getCreateAssessmentTypeMutationOptions(options), queryClient);
    }
    export const getUpdateAssessmentTypeUrl = (assessmentTypeId: string,) => {




  return `/v1/assessment-types/${assessmentTypeId}`
}

/**
 * Exclusiva de Super Admin. Alterar um tipo nao altera nota ja lancada: o
 * peso e congelado no lancamento.
 * @summary Altera um tipo de avaliacao
 */
export const updateAssessmentType = async (assessmentTypeId: string,
    updateAssessmentTypeRequest: UpdateAssessmentTypeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<AssessmentType> => {

  return apiFetch<AssessmentType>(getUpdateAssessmentTypeUrl(assessmentTypeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAssessmentTypeRequest)
  }
);}





export const getUpdateAssessmentTypeMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssessmentType>>, TError,{assessmentTypeId: string;data: UpdateAssessmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssessmentType>>, TError,{assessmentTypeId: string;data: UpdateAssessmentTypeRequest}, TContext> => {

const mutationKey = ['updateAssessmentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssessmentType>>, {assessmentTypeId: string;data: UpdateAssessmentTypeRequest}> = (props) => {
          const {assessmentTypeId,data} = props ?? {};

          return  updateAssessmentType(assessmentTypeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssessmentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssessmentType>>>
    export type UpdateAssessmentTypeMutationBody = UpdateAssessmentTypeRequest
    export type UpdateAssessmentTypeMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Altera um tipo de avaliacao
 */
export const useUpdateAssessmentType = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssessmentType>>, TError,{assessmentTypeId: string;data: UpdateAssessmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAssessmentType>>,
        TError,
        {assessmentTypeId: string;data: UpdateAssessmentTypeRequest},
        TContext
      > => {
      return useMutation(getUpdateAssessmentTypeMutationOptions(options), queryClient);
    }
    export const getListGradeScalesUrl = () => {




  return `/v1/grade-scales`
}

/**
 * As escalas em si continuam abertas na §15.2 e nascem como conteudo
 * provisorio.
 * @summary Lista escalas de nota configuradas
 */
export const listGradeScales = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GradeScale[]> => {

  return apiFetch<GradeScale[]>(getListGradeScalesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGradeScalesQueryKey = () => {
    return [
    `/v1/grade-scales`
    ] as const;
    }


export const getListGradeScalesQueryOptions = <TData = Awaited<ReturnType<typeof listGradeScales>>, TError = UnauthorizedResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGradeScales>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGradeScalesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGradeScales>>> = ({ signal }) => listGradeScales({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGradeScales>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGradeScalesQueryResult = NonNullable<Awaited<ReturnType<typeof listGradeScales>>>
export type ListGradeScalesQueryError = UnauthorizedResponse


export function useListGradeScales<TData = Awaited<ReturnType<typeof listGradeScales>>, TError = UnauthorizedResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGradeScales>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGradeScales>>,
          TError,
          Awaited<ReturnType<typeof listGradeScales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGradeScales<TData = Awaited<ReturnType<typeof listGradeScales>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGradeScales>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGradeScales>>,
          TError,
          Awaited<ReturnType<typeof listGradeScales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGradeScales<TData = Awaited<ReturnType<typeof listGradeScales>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGradeScales>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista escalas de nota configuradas
 */

export function useListGradeScales<TData = Awaited<ReturnType<typeof listGradeScales>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGradeScales>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGradeScalesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateGradeScaleUrl = () => {




  return `/v1/grade-scales`
}

/**
 * Exclusiva de Super Admin.
 * @summary Cria uma escala de nota
 */
export const createGradeScale = async (createGradeScaleRequest: CreateGradeScaleRequest, options?: Parameters<typeof apiFetch>[1]): Promise<GradeScale> => {

  return apiFetch<GradeScale>(getCreateGradeScaleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createGradeScaleRequest)
  }
);}





export const getCreateGradeScaleMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGradeScale>>, TError,{data: CreateGradeScaleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGradeScale>>, TError,{data: CreateGradeScaleRequest}, TContext> => {

const mutationKey = ['createGradeScale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGradeScale>>, {data: CreateGradeScaleRequest}> = (props) => {
          const {data} = props ?? {};

          return  createGradeScale(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGradeScaleMutationResult = NonNullable<Awaited<ReturnType<typeof createGradeScale>>>
    export type CreateGradeScaleMutationBody = CreateGradeScaleRequest
    export type CreateGradeScaleMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Cria uma escala de nota
 */
export const useCreateGradeScale = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGradeScale>>, TError,{data: CreateGradeScaleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGradeScale>>,
        TError,
        {data: CreateGradeScaleRequest},
        TContext
      > => {
      return useMutation(getCreateGradeScaleMutationOptions(options), queryClient);
    }
    export const getListMaterialsUrl = (params?: ListMaterialsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/materials?${stringifiedParams}` : `/v1/materials`
}

/**
 * Depende de `academic`, que e Onda 2, e do
 * bucket privado de materiais, que e provisionamento manual.
 * @summary Lista materiais acessiveis ao solicitante
 */
export const listMaterials = async (params?: ListMaterialsParams, options?: Parameters<typeof apiFetch>[1]): Promise<MaterialPage> => {

  return apiFetch<MaterialPage>(getListMaterialsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMaterialsQueryKey = (params?: ListMaterialsParams,) => {
    return [
    `/v1/materials`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof listMaterials>>, TError = UnauthorizedResponse>(params?: ListMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMaterialsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMaterials>>> = ({ signal }) => listMaterials(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof listMaterials>>>
export type ListMaterialsQueryError = UnauthorizedResponse


export function useListMaterials<TData = Awaited<ReturnType<typeof listMaterials>>, TError = UnauthorizedResponse>(
 params: undefined |  ListMaterialsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMaterials>>,
          TError,
          Awaited<ReturnType<typeof listMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMaterials<TData = Awaited<ReturnType<typeof listMaterials>>, TError = UnauthorizedResponse>(
 params?: ListMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMaterials>>,
          TError,
          Awaited<ReturnType<typeof listMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMaterials<TData = Awaited<ReturnType<typeof listMaterials>>, TError = UnauthorizedResponse>(
 params?: ListMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista materiais acessiveis ao solicitante
 */

export function useListMaterials<TData = Awaited<ReturnType<typeof listMaterials>>, TError = UnauthorizedResponse>(
 params?: ListMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMaterialsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateMaterialUrl = () => {




  return `/v1/materials`
}

/**
 * A politica de material — tipos aceitos e limite de tamanho — continua
 * aberta na §15.2 e nasce conservadora; enquanto for provisoria, esta
 * operacao responde 503.
 *
 * O contrato nao tem campo de nome de arquivo original. O titulo e texto
 * que o autor escreve, e o nome do objeto e gerado pelo servidor: nome de
 * arquivo enviado por terceiro e um canal por onde nome completo entraria
 * no sistema sem passar pelo modulo `identity`.
 * @summary Registra um material e devolve a URL de upload
 */
export const createMaterial = async (createMaterialRequest: CreateMaterialRequest, options?: Parameters<typeof apiFetch>[1]): Promise<MaterialUpload> => {

  return apiFetch<MaterialUpload>(getCreateMaterialUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMaterialRequest)
  }
);}





export const getCreateMaterialMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMaterial>>, TError,{data: CreateMaterialRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMaterial>>, TError,{data: CreateMaterialRequest}, TContext> => {

const mutationKey = ['createMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMaterial>>, {data: CreateMaterialRequest}> = (props) => {
          const {data} = props ?? {};

          return  createMaterial(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof createMaterial>>>
    export type CreateMaterialMutationBody = CreateMaterialRequest
    export type CreateMaterialMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse

    /**
 * @summary Registra um material e devolve a URL de upload
 */
export const useCreateMaterial = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMaterial>>, TError,{data: CreateMaterialRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMaterial>>,
        TError,
        {data: CreateMaterialRequest},
        TContext
      > => {
      return useMutation(getCreateMaterialMutationOptions(options), queryClient);
    }
    export const getCreateMaterialDownloadURLUrl = (materialId: string,) => {




  return `/v1/materials/${materialId}/download-url`
}

/**
 * Depende de `academic`, que e Onda 2, e do
 * bucket privado de materiais.
 * @summary Emite URL assinada de download de um material
 */
export const createMaterialDownloadURL = async (materialId: string, options?: Parameters<typeof apiFetch>[1]): Promise<SignedURL> => {

  return apiFetch<SignedURL>(getCreateMaterialDownloadURLUrl(materialId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateMaterialDownloadURLMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMaterialDownloadURL>>, TError,{materialId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMaterialDownloadURL>>, TError,{materialId: string}, TContext> => {

const mutationKey = ['createMaterialDownloadURL'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMaterialDownloadURL>>, {materialId: string}> = (props) => {
          const {materialId} = props ?? {};

          return  createMaterialDownloadURL(materialId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMaterialDownloadURLMutationResult = NonNullable<Awaited<ReturnType<typeof createMaterialDownloadURL>>>

    export type CreateMaterialDownloadURLMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Emite URL assinada de download de um material
 */
export const useCreateMaterialDownloadURL = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMaterialDownloadURL>>, TError,{materialId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMaterialDownloadURL>>,
        TError,
        {materialId: string},
        TContext
      > => {
      return useMutation(getCreateMaterialDownloadURLMutationOptions(options), queryClient);
    }
    export const getDeleteMaterialUrl = (materialId: string,) => {




  return `/v1/materials/${materialId}`
}

/**
 * Autor e Super Admin.
 * @summary Remove um material
 */
export const deleteMaterial = async (materialId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDeleteMaterialUrl(materialId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteMaterialMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMaterial>>, TError,{materialId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMaterial>>, TError,{materialId: string}, TContext> => {

const mutationKey = ['deleteMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMaterial>>, {materialId: string}> = (props) => {
          const {materialId} = props ?? {};

          return  deleteMaterial(materialId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMaterial>>>

    export type DeleteMaterialMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Remove um material
 */
export const useDeleteMaterial = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMaterial>>, TError,{materialId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMaterial>>,
        TError,
        {materialId: string},
        TContext
      > => {
      return useMutation(getDeleteMaterialMutationOptions(options), queryClient);
    }
